import { render, staticRenderFns } from "./StatsHorizontalBarChart.vue?vue&type=template&id=c1fed912"
import script from "./StatsHorizontalBarChart.vue?vue&type=script&lang=js"
export * from "./StatsHorizontalBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports